import { render, staticRenderFns } from "./ReportingContent.vue?vue&type=template&id=72ed97bd&scoped=true&"
import script from "./ReportingContent.vue?vue&type=script&lang=js&"
export * from "./ReportingContent.vue?vue&type=script&lang=js&"
import style0 from "./ReportingContent.vue?vue&type=style&index=0&id=72ed97bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ed97bd",
  null
  
)

export default component.exports